import cx from 'classnames';

import styles from './iq-cursor-orb.module.scss';

interface IQCursorOrbProps {
  speed?: 'SLOW' | 'MEDIUM' | 'FAST';
}

export default function IQCursorOrb({ speed = 'MEDIUM' }: IQCursorOrbProps) {
  const animationSpeed = speed.toLowerCase();
  return <span className={cx(styles['iq-cursor-orb'], styles[`iq-cursor-orb--${animationSpeed}`])}></span>;
}
